/* TIKUN — כיתוב אישי חרוט
   v13 (פידבק איתן): סליידר הגודל 50%-100% — 100% = הגדול ביותר שנכנס באזור (ברירת מחדל).
   v12: תמחור לפי חלקים בקופת 770 — כיתוב על הבסיס (מיקומים 0-2) = 49 ₪,
   על גוף הקופה (מיקומים 3-4) = 49 ₪, על שניהם = 98 ₪ (וריאנט "עם" + פריט תוספת). לא משנה מה כותבים בכל חלק.
   v11: הוסרה אופציית "גב הבסיס" (5 מיקומים) · הכיתוב הקבוע בחזית — 5 אפשרויות:
   המלא (ברירת מחדל) / 770 בלבד / יחי אדוננו... / צדקה / בלי טקסט.
   v10: סליידר הגודל מוצג תמיד (מעומעם כשאין טקסט).
   v9 (קופת 770): טקסט נפרד לכל מיקום + סליידר גודל (זוגות סימטריים מסונכרנים) ·
   properties לכל מיקום: "כיתוב — <מיקום>" + "גודל הכיתוב — <מיקום>" (רק כשיש טקסט).
   במוצרים אחרים — הזרימה הישנה (פר-פריט) ללא שינוי. v6: nativeSubmit תמיד אסינכרוני. */
(function () {
  var C = window.TIKUN_ENGRAVE;
  if (!C || (!C.isKupa && !C.isAddon)) return;

  var RTL = !!C.rtl;
  var PRICE = C.price || 49;
  var FRONT_FULL_TXT = '770 EASTERN PARKWAY N.Y.';
  var FRONT_YECHI_TXT = 'יחי אדוננו מורנו ורבינו מלך המשיח לעולם ועד';
  var FRONT_TZEDAKA_TXT = 'צדקה';
  var T = RTL
    ? {
        toggle: 'הוסיפו חריטה / כיתוב מותאם אישית',
        price: PRICE + ' ₪',
        perItem: 'לפריט',
        perPart: 'לחלק',
        zoneNote: 'המחיר לפי חלק: כיתוב על הבסיס — ' + PRICE + ' ₪ · על גוף הקופה — ' + PRICE + ' ₪ · על שניהם — ' + (PRICE * 2) + ' ₪. אין הגבלה על מספר המיקומים בתוך אותו חלק.',
        zoneBoth: 'שני חלקים',
        lead: 'שם משפחה, הקדשה, שם בית הכנסת או "יחי אדוננו" — נחרט בגוף המוצר עצמו.',
        label: 'מה לחרוט?',
        itemLbl: 'פריט [i]',
        ph: 'לדוגמה: משפחת כהן · הוד השרון',
        phEmpty: 'ריק = בלי כיתוב',
        phLoc: 'ריק = בלי כיתוב במיקום הזה',
        left: 'נשארו [n] תווים',
        sum: '[k] כיתובים',
        sumOne: 'כיתוב אחד',
        rows: 'עד שתי שורות בכל מיקום',
        size: 'עד [n] תווים למיקום, למידה [s]',
        sizeNoLbl: 'עד [n] תווים למיקום',
        empty: 'רשמו נוסח לפחות במיקום אחד, או בטלו את הסימון.',
        emptyItems: 'רשמו נוסח לפחות לפריט אחד, או בטלו את הסימון.',
        proof: 'נשלח אליכם הדמיה לאישור לפני ההדפסה · מוסיף כ־2–3 ימי עסקים',
        locations: ['חזית הבסיס', 'צד ימין של הבסיס', 'צד שמאל של הבסיס', 'גב הקופה — מימין', 'גב הקופה — משמאל'],
        locFrontNote: 'הכיתוב הזה מחליף את הכיתוב הקבוע שבחזית.',
        sizeLbl: 'גודל הכיתוב',
        sizeHint: '100% = הגדול ביותר שנכנס באזור',
        sizePair: 'בשני צדדים סימטריים הגודל נשמר זהה',
        frontGroupTtl: 'הכיתוב הקבוע בחזית הבסיס',
        frontFull: '"' + FRONT_FULL_TXT + '" (ברירת המחדל)',
        front770: '"770" בלבד',
        frontYechi: '"' + FRONT_YECHI_TXT + '"',
        frontTzedaka: '"' + FRONT_TZEDAKA_TXT + '"',
        frontNone: 'בלי טקסט בחזית',
        frontBlocked: 'בחרתם כיתוב אישי בחזית — הוא מחליף את הכיתוב הקבוע, כך שהבחירה הזו לא רלוונטית.',
        designTtl: 'עיצוב מותאם אישית',
        designLead: 'רוצים שינוי שלא מופיע באפשרויות? ספרו לנו בדיוק מה — ונחזור אליכם לפני הייצור.',
        designPh: 'תארו במדויק מה תרצו לשנות…',
        designEmpty: 'תארו מה תרצו לשנות, או בטלו את הסימון.',
        designNote: 'עיצוב מותאם אישית עשוי להיות כרוך בתוספת תשלום — נחזור אליכם עם אישור ומחיר לפני הייצור.',
        addonLabel: 'הנוסח לחריטה',
        addonNote: 'התוספת נמכרת יחד עם מוצר מהחנות.',
        addonBlocked: 'כדי להוסיף כיתוב — קודם מוסיפים מוצר לסל 🙂',
        addonMax: 'אפשר עד [n] כיתובים לפי המוצרים שבסל.'
      }
    : {
        toggle: 'Add a custom engraving',
        price: '₪' + PRICE,
        perItem: 'per item',
        perPart: 'per part',
        zoneNote: 'Priced per part: base engraving — ₪' + PRICE + ' · box engraving — ₪' + PRICE + ' · both — ₪' + (PRICE * 2) + '. Any number of locations within the same part.',
        zoneBoth: 'both parts',
        lead: 'A family name, a dedication, a synagogue name — engraved into the product itself.',
        label: 'What should it say?',
        itemLbl: 'Item [i]',
        ph: 'e.g. The Cohen Family · Hod Hasharon',
        phEmpty: 'Leave empty for no engraving',
        phLoc: 'Leave empty for no engraving here',
        left: '[n] characters left',
        sum: '[k] engravings',
        sumOne: '1 engraving',
        rows: 'Up to two lines per location',
        size: 'up to [n] characters per location, size [s]',
        sizeNoLbl: 'up to [n] characters per location',
        empty: 'Type a text in at least one location, or uncheck the box.',
        emptyItems: 'Type a text for at least one item, or uncheck the box.',
        proof: 'We send a proof for your approval before printing · adds 2–3 business days',
        locations: ['Front of the base', 'Right side of the base', 'Left side of the base', 'Back of the box — right side', 'Back of the box — left side'],
        locFrontNote: 'This text replaces the standard front inscription.',
        sizeLbl: 'Text size',
        sizeHint: '100% = the largest that fits the area',
        sizePair: 'Symmetric sides keep the same size',
        frontGroupTtl: 'Standard front inscription',
        frontFull: '"' + FRONT_FULL_TXT + '" (default)',
        front770: '"770" only',
        frontYechi: '"Yechi Adoneinu Moreinu VeRabbeinu Melech HaMoshiach LeOlam Voed"',
        frontTzedaka: '"Tzedakah" (צדקה)',
        frontNone: 'No front inscription',
        frontBlocked: 'You chose a custom engraving on the front — it replaces the standard inscription, so this choice does not apply.',
        designTtl: 'Custom design',
        designLead: 'Want a change that is not listed here? Tell us exactly what — we will get back to you before production.',
        designPh: 'Describe exactly what you would like to change…',
        designEmpty: 'Describe what you would like to change, or uncheck the box.',
        designNote: 'A custom design may involve an extra charge — we will confirm the details and price with you before production.',
        addonLabel: 'Text to engrave',
        addonNote: 'This add-on is sold together with a product from the store.',
        addonBlocked: 'To add an engraving, first add a product to your cart 🙂',
        addonMax: 'Up to [n] engravings for the items in your cart.'
      };

  var PROP = RTL ? 'כיתוב אישי' : 'Engraving';
  var PROP_TEXT = RTL ? 'הנוסח' : 'Text';
  var PROP_FOR = RTL ? 'עבור' : 'For';
  var PROP_LOC = RTL ? 'מיקום החריטה' : 'Engraving location';
  var PROP_LOC_PREFIX = RTL ? 'כיתוב — ' : 'Engraving — ';
  var PROP_SIZE_PREFIX = RTL ? 'גודל הכיתוב — ' : 'Text size — ';
  var PROP_FRONT = RTL ? 'כיתוב בחזית' : 'Front inscription';
  var FRONT_VAL = RTL ? '770 בלבד' : '770 only';
  var FRONT_NONE_VAL = RTL ? 'בלי טקסט' : 'No text';
  var PROP_DESIGN = RTL ? 'בקשת עיצוב מיוחד' : 'Custom design request';
  var MAXFALLBACK = 55;

  function css() {
    if (document.getElementById('tikun-engrave-css')) return;
    var s = document.createElement('style');
    s.id = 'tikun-engrave-css';
    s.textContent =
      '.tkeng{border:1px solid #e7d9b4;border-top:3px solid #c9a24b;background:#fbf6e9;border-radius:12px;padding:14px 16px;margin:0 0 18px;font-size:1.4rem;line-height:1.6;color:#4a3a12}' +
      '.tkeng--sub{margin-top:-6px}' +
      '.tkeng__row{display:flex;align-items:flex-start;gap:10px;cursor:pointer}' +
      '.tkeng__row input{margin:4px 0 0;width:18px;height:18px;accent-color:#a3801f;flex:0 0 auto;cursor:pointer}' +
      '.tkeng__row input:disabled{cursor:not-allowed}' +
      '.tkeng.is-blocked{opacity:.62}' +
      '.tkeng__ttl{font-weight:700;color:#6e5312}' +
      '.tkeng__price{color:#a3801f;font-weight:700;white-space:nowrap}' +
      '.tkeng__lead{margin:4px 0 0;font-size:1.3rem;color:#5a4d33}' +
      '.tkeng__body{margin-top:12px;display:none}' +
      '.tkeng.is-open .tkeng__body{display:block}' +
      '.tkeng__lbl{display:block;font-weight:600;margin:0 0 6px;color:#6e5312}' +
      '.tkeng__unit{display:flex;align-items:center;gap:8px;margin:0 0 8px}' +
      '.tkeng__unitlbl{flex:0 0 auto;min-width:52px;font-size:1.25rem;font-weight:600;color:#8a7a55}' +
      '.tkeng__ta{width:100%;box-sizing:border-box;padding:9px 12px;border:1px solid #d9c58f;border-radius:8px;background:#fffdf6;font:inherit;color:#1f1a12;resize:none;min-height:42px}' +
      '.tkeng--single .tkeng__ta{min-height:64px}' +
      '.tkeng__ta:focus{outline:2px solid #c9a24b;outline-offset:1px}' +
      '.tkeng__meta{display:flex;flex-wrap:wrap;gap:4px 14px;justify-content:space-between;margin-top:4px;font-size:1.2rem;color:#8a7a55}' +
      '.tkeng__sum{font-weight:700;color:#a3801f}' +
      '.tkeng__err{color:#9b2c2c;font-weight:600;margin-top:6px;font-size:1.3rem;display:none}' +
      '.tkeng.is-err .tkeng__err{display:block}' +
      '.tkeng__note{margin:8px 0 0;font-size:1.2rem;color:#8a7a55}' +
      '.tkeng__proof{margin:10px 0 0;font-size:1.2rem;color:#8a7a55}' +
      /* שורת מיקום (v9) */
      '.tkloc{margin:0 0 10px;padding:9px 11px;border:1px solid #e7d9b4;border-radius:10px;background:#fffdf6}' +
      '.tkloc__name{display:block;font-weight:700;font-size:1.25rem;color:#6e5312;margin:0 0 5px}' +
      '.tkloc .tkeng__ta{min-height:38px;background:#fff}' +
      '.tkloc__frontnote{display:none;margin:4px 0 0;font-size:1.15rem;color:#a3801f;font-weight:600}' +
      '.tkloc.is-filled .tkloc__frontnote{display:block}' +
      '.tkloc__sizerow{display:flex;align-items:center;gap:8px;margin:7px 0 0;font-size:1.2rem;color:#8a7a55;opacity:.45;transition:opacity .15s}' +
      '.tkloc.is-filled .tkloc__sizerow{opacity:1}' +
      '.tkloc__size{flex:1 1 auto;accent-color:#a3801f;cursor:pointer;min-width:80px}' +
      '.tkloc__pct{flex:0 0 auto;font-weight:700;color:#6e5312;min-width:38px;text-align:center}' +
      '.tkloc__sizehint{flex:0 0 100%;font-size:1.05rem;color:#a89a76}' +
      '.tkloc__pairnote{flex:0 0 100%;font-size:1.05rem;color:#8a7a55;display:none}' +
      '.tkloc.is-paired .tkloc__pairnote{display:block}' +
      /* קבוצת הכיתוב הקבוע בחזית */
      '.tkfront__ttl{font-weight:700;color:#6e5312;margin:0 0 6px}' +
      '.tkfront__opt{display:flex;align-items:flex-start;gap:8px;cursor:pointer;margin:0 0 5px;font-size:1.3rem}' +
      '.tkfront__opt input{margin:3px 0 0;width:16px;height:16px;accent-color:#a3801f;flex:0 0 auto;cursor:pointer}' +
      '.tkfront__blocked{display:none;margin:4px 0 0;font-size:1.2rem;color:#a3801f;font-weight:600}' +
      '.tkeng.is-blocked .tkfront__blocked{display:block}';
    document.head.appendChild(s);
  }

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  function clampLines(v) {
    var parts = v.split(/\r?\n/);
    if (parts.length <= 2) return v;
    return parts.slice(0, 2).join('\n');
  }

  function findForm() {
    return document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"][data-type="add-to-cart-form"]');
  }

  function currentLimit(form) {
    var idInput = form.querySelector('input[name="id"]');
    var info = idInput && C.limits ? C.limits[idInput.value] : null;
    if (!info) return { n: MAXFALLBACK, label: '' };
    return info;
  }

  function qtyInputOf(form) {
    var e = form.elements ? form.elements.namedItem('quantity') : null;
    return e || form.querySelector('input[name="quantity"]');
  }

  function currentQty(form) {
    var q = qtyInputOf(form);
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function engMode() {
    for (var k in C.limits) if (C.limits[k] && C.limits[k].eng === 'עם') return true;
    return false;
  }

  function twinOf(vid) {
    var cur = C.limits ? C.limits[vid] : null;
    if (!cur) return null;
    for (var k in C.limits) {
      var v = C.limits[k];
      if (v && v.eng === 'עם' && v.o1 === cur.o1 && v.o2 === cur.o2) return k;
    }
    return null;
  }

  function hideEngPicker() {
    var els = document.querySelectorAll('input[type="radio"], select');
    for (var i = 0; i < els.length; i++) {
      var el2 = els[i];
      var nm = el2.getAttribute('name') || '';
      if (nm.indexOf('כיתוב') !== 0) continue;
      var box = el2.closest('fieldset') || el2.closest('.product-form__input') || el2.parentElement;
      if (box && box.style.display !== 'none') box.style.display = 'none';
      if (el2.tagName === 'SELECT') { if (el2.value !== 'בלי') el2.value = 'בלי'; }
      else if (el2.value === 'בלי' && !el2.checked) el2.checked = true;
    }
  }

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
  }

  /* ---------- קופת 770: טקסט לכל מיקום + סליידר גודל ---------- */
  function init770() {
    var form = findForm();
    if (!form) return false;
    if (form.dataset.tkengReady === '1') return true;
    form.dataset.tkengReady = '1';

    css();
    var wrap = el('div', 'tkeng tkeng--single');
    wrap.dir = RTL ? 'rtl' : 'ltr';

    var row = el('label', 'tkeng__row');
    var cb = el('input');
    cb.type = 'checkbox';
    cb.id = 'tkeng-toggle';
    row.appendChild(cb);
    var rtxt = el('span');
    rtxt.appendChild(el('span', 'tkeng__ttl', T.toggle + ' '));
    rtxt.appendChild(el('span', 'tkeng__price', '+' + T.price + ' ' + T.perPart));
    var lead = el('span', 'tkeng__lead', T.lead);
    lead.style.display = 'block';
    rtxt.appendChild(lead);
    var zlead = el('span', 'tkeng__lead', T.zoneNote);
    zlead.style.display = 'block';
    rtxt.appendChild(zlead);
    row.appendChild(rtxt);
    wrap.appendChild(row);

    var body = el('div', 'tkeng__body');
    body.appendChild(el('label', 'tkeng__lbl', T.label));

    // 5 שורות מיקום: טקסט + סליידר גודל · חלקים לתמחור: בסיס = 0-2, גוף הקופה = 3-4
    var PAIRS = { 1: 2, 2: 1, 3: 4, 4: 3 };
    var BASE_ZONE_MAX = 2;
    var locRows = [];
    var fields = el('div', 'tkeng__fields');
    for (var i = 0; i < T.locations.length; i++) {
      (function (idx) {
        var lr = el('div', 'tkloc');
        lr.setAttribute('data-tkloc', String(idx));
        lr.appendChild(el('label', 'tkloc__name', T.locations[idx]));
        var ta = el('textarea', 'tkeng__ta tkloc__ta');
        ta.rows = 1;
        ta.placeholder = idx === 0 ? T.ph : T.phLoc;
        ta.setAttribute('data-tkloc-ta', String(idx));
        ta.disabled = true;
        lr.appendChild(ta);
        if (idx === 0) lr.appendChild(el('div', 'tkloc__frontnote', T.locFrontNote));
        var sr = el('div', 'tkloc__sizerow');
        sr.appendChild(el('span', null, T.sizeLbl));
        var rng = document.createElement('input');
        rng.type = 'range';
        rng.className = 'tkloc__size';
        rng.min = '50'; rng.max = '100'; rng.step = '5'; rng.value = '100';
        rng.setAttribute('data-tkloc-size', String(idx));
        sr.appendChild(rng);
        var pct = el('span', 'tkloc__pct', '100%');
        sr.appendChild(pct);
        sr.appendChild(el('span', 'tkloc__sizehint', T.sizeHint));
        sr.appendChild(el('span', 'tkloc__pairnote', T.sizePair));
        lr.appendChild(sr);
        fields.appendChild(lr);
        locRows.push({ row: lr, ta: ta, rng: rng, pct: pct, idx: idx });
      })(i);
    }
    body.appendChild(fields);

    var meta = el('div', 'tkeng__meta');
    var sum = el('span', 'tkeng__sum', '');
    var sizeNote = el('span', 'tkeng__size', '');
    meta.appendChild(sum);
    meta.appendChild(sizeNote);
    body.appendChild(meta);

    body.appendChild(el('div', 'tkeng__err', T.empty));
    body.appendChild(el('p', 'tkeng__proof', T.rows + ' · ' + T.proof));
    wrap.appendChild(body);

    var host = form.closest('product-form') || form;
    (host.parentNode || document.body).insertBefore(wrap, host);

    // הכיתוב הקבוע בחזית — 5 אפשרויות (התנהגות רדיו, ברירת מחדל: המלא)
    var frontWrap = el('div', 'tkeng tkeng--sub');
    frontWrap.dir = RTL ? 'rtl' : 'ltr';
    frontWrap.appendChild(el('div', 'tkfront__ttl', T.frontGroupTtl));
    function frontOpt(id, label, checked) {
      var lab = el('label', 'tkfront__opt');
      var c = el('input');
      c.type = 'checkbox';
      c.id = id;
      c.checked = !!checked;
      lab.appendChild(c);
      lab.appendChild(el('span', null, label));
      frontWrap.appendChild(lab);
      return c;
    }
    var frontFullCb = frontOpt('tkeng-front-full', T.frontFull, true);
    var front770Cb = frontOpt('tkeng-front', T.front770, false);
    var frontYechiCb = frontOpt('tkeng-front-yechi', T.frontYechi, false);
    var frontTzedakaCb = frontOpt('tkeng-front-tzedaka', T.frontTzedaka, false);
    var frontNoneCb = frontOpt('tkeng-front-none', T.frontNone, false);
    var frontCbs = [frontFullCb, front770Cb, frontYechiCb, frontTzedakaCb, frontNoneCb];
    frontWrap.appendChild(el('div', 'tkfront__blocked', T.frontBlocked));
    (host.parentNode || document.body).insertBefore(frontWrap, host);
    frontCbs.forEach(function (c) {
      c.addEventListener('change', function () {
        if (c.checked) frontCbs.forEach(function (o) { if (o !== c) o.checked = false; });
        else c.checked = true; // תמיד אחד מסומן
      });
    });

    // עיצוב מותאם אישית — טקסט חופשי
    var designWrap = el('div', 'tkeng tkeng--sub tkeng--single');
    designWrap.dir = RTL ? 'rtl' : 'ltr';
    var drow = el('label', 'tkeng__row');
    var designCb = el('input');
    designCb.type = 'checkbox';
    designCb.id = 'tkeng-design';
    drow.appendChild(designCb);
    var dtxt = el('span');
    dtxt.appendChild(el('span', 'tkeng__ttl', T.designTtl));
    var dlead = el('span', 'tkeng__lead', T.designLead);
    dlead.style.display = 'block';
    dtxt.appendChild(dlead);
    drow.appendChild(dtxt);
    designWrap.appendChild(drow);
    var dbody = el('div', 'tkeng__body');
    var designTa = el('textarea', 'tkeng__ta');
    designTa.rows = 3;
    designTa.placeholder = T.designPh;
    designTa.setAttribute('maxlength', '300');
    designTa.disabled = true;
    dbody.appendChild(designTa);
    var derr = el('div', 'tkeng__err', T.designEmpty);
    dbody.appendChild(derr);
    dbody.appendChild(el('p', 'tkeng__note', T.designNote));
    designWrap.appendChild(dbody);
    (host.parentNode || document.body).insertBefore(designWrap, host);

    designCb.addEventListener('change', function () {
      designWrap.classList.toggle('is-open', designCb.checked);
      designTa.disabled = !designCb.checked;
      designWrap.classList.remove('is-err');
      if (designCb.checked) setTimeout(function () { designTa.focus(); }, 30);
    });
    designTa.addEventListener('input', function () {
      designWrap.classList.remove('is-err');
    });

    var limit = currentLimit(form);

    function filled() {
      return locRows.filter(function (r) { return r.ta.value.trim(); });
    }

    // כמה "חלקים" בשימוש: בסיס (0-2) ו/או גוף הקופה (3-4)
    function zonesUsed() {
      var f = filled();
      var base = f.some(function (r) { return r.idx <= BASE_ZONE_MAX; }) ? 1 : 0;
      var box = f.some(function (r) { return r.idx > BASE_ZONE_MAX; }) ? 1 : 0;
      return base + box;
    }

    function syncFront() {
      var blocked = cb.checked && !!locRows[0].ta.value.trim();
      frontCbs.forEach(function (c) { c.disabled = blocked; });
      frontWrap.classList.toggle('is-blocked', blocked);
    }

    function paintMeta() {
      var k = filled().length;
      var z = zonesUsed();
      var priceTxt = z === 0 ? '' : ' · +' + (PRICE * z) + ' ₪' + (z === 2 ? ' (' + T.zoneBoth + ')' : '');
      sum.textContent = k === 0 ? '' : (k === 1 ? T.sumOne : T.sum.replace('[k]', String(k))) + priceTxt;
      sizeNote.textContent = limit.label
        ? T.size.replace('[s]', limit.label).replace('[n]', String(limit.n))
        : T.sizeNoLbl.replace('[n]', String(limit.n));
    }

    function pairSync(idx) {
      var p = PAIRS[idx];
      if (p == null) return;
      var a = locRows[idx], b = locRows[p];
      var both = a.ta.value.trim() && b.ta.value.trim();
      a.row.classList.toggle('is-paired', !!both);
      b.row.classList.toggle('is-paired', !!both);
      if (both) {
        b.rng.value = a.rng.value;
        b.pct.textContent = a.rng.value + '%';
      }
    }

    locRows.forEach(function (r) {
      r.ta.addEventListener('input', function () {
        var v = clampLines(r.ta.value);
        if (v.length > limit.n) v = v.slice(0, limit.n);
        if (v !== r.ta.value) r.ta.value = v;
        r.row.classList.toggle('is-filled', !!r.ta.value.trim());
        wrap.classList.remove('is-err');
        if (r.idx === 0) syncFront();
        pairSync(r.idx);
        paintMeta();
      });
      r.rng.addEventListener('input', function () {
        r.pct.textContent = r.rng.value + '%';
        pairSync(r.idx);
      });
    });

    function refreshState() {
      var nextL = currentLimit(form);
      if (nextL.n !== limit.n || nextL.label !== limit.label) {
        limit = nextL;
        locRows.forEach(function (r) {
          r.ta.setAttribute('maxlength', String(limit.n));
          if (r.ta.value.length > limit.n) r.ta.value = r.ta.value.slice(0, limit.n);
        });
        paintMeta();
      }
      if (engMode()) hideEngPicker();
    }

    cb.addEventListener('change', function () {
      wrap.classList.toggle('is-open', cb.checked);
      locRows.forEach(function (r) { r.ta.disabled = !cb.checked; });
      wrap.classList.remove('is-err');
      syncFront();
    });

    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.addEventListener('change', refreshState);
    setInterval(refreshState, 500);
    locRows.forEach(function (r) { r.ta.setAttribute('maxlength', String(limit.n)); });
    paintMeta();
    syncFront();
    if (engMode()) hideEngPicker();

    function sharedProps() {
      var p = {};
      if (!frontFullCb.disabled) {
        if (front770Cb.checked) p[PROP_FRONT] = FRONT_VAL;
        else if (frontYechiCb.checked) p[PROP_FRONT] = FRONT_YECHI_TXT;
        else if (frontTzedakaCb.checked) p[PROP_FRONT] = FRONT_TZEDAKA_TXT;
        else if (frontNoneCb.checked) p[PROP_FRONT] = FRONT_NONE_VAL;
      }
      if (designCb.checked && designTa.value.trim()) p[PROP_DESIGN] = designTa.value.trim();
      return p;
    }

    function engraveProps() {
      var p = {};
      filled().forEach(function (r) {
        p[PROP_LOC_PREFIX + T.locations[r.idx]] = r.ta.value.trim();
        p[PROP_SIZE_PREFIX + T.locations[r.idx]] = r.rng.value + '%';
      });
      return p;
    }

    function clearOldHidden() {
      var olds = form.querySelectorAll('input[data-tkeng-prop="1"]');
      for (var i = 0; i < olds.length; i++) olds[i].remove();
    }

    function addHiddenProps(props) {
      var added = [];
      for (var k in props) {
        var hi = document.createElement('input');
        hi.type = 'hidden';
        hi.name = 'properties[' + k + ']';
        hi.value = props[k];
        hi.setAttribute('data-tkeng-prop', '1');
        form.appendChild(hi);
        added.push(hi);
      }
      setTimeout(function () { added.forEach(function (h) { h.remove(); }); }, 2000);
      return added;
    }

    function validateDesign() {
      if (designCb.checked && !designTa.value.trim()) {
        designWrap.classList.add('is-err');
        designTa.focus();
        return false;
      }
      return true;
    }

    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (form.dataset.tkengPass === '1') { form.dataset.tkengPass = '0'; return; }

      if (!validateDesign()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      if (!cb.checked) {
        var sp = sharedProps();
        clearOldHidden();
        var hasShared = false;
        for (var kk in sp) { hasShared = true; break; }
        if (hasShared) addHiddenProps(sp);
        return;
      }

      if (!filled().length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        wrap.classList.add('is-err');
        locRows[0].ta.focus();
        return;
      }

      // כל היחידות בהוספה הזו מקבלות את אותם כיתובים — פריט אחד, וריאנט "עם" אם קיים.
      // תמחור לפי חלקים: וריאנט "עם" = חלק ראשון (49 ₪); שימוש בשני החלקים (בסיס+גוף) — פריט תוספת שני (49 ₪) → 98 ₪.
      e.preventDefault();
      e.stopImmediatePropagation();
      var idInputEl = form.querySelector('input[name="id"]');
      var baseIdStr = idInputEl.value;
      var twinStr = engMode() ? twinOf(baseIdStr) : null;
      var props = engraveProps();
      var shared = sharedProps();
      for (var sk in shared) props[sk] = shared[sk];
      var needAddon = zonesUsed() === 2 && C.addonVariantId;

      function nativeSubmit770() {
        var swapped = false;
        clearOldHidden();
        addHiddenProps(props);
        if (twinStr) { idInputEl.value = twinStr; swapped = true; }
        form.dataset.tkengPass = '1';
        setTimeout(function () {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
          if (swapped) idInputEl.value = baseIdStr;
          setTimeout(function () { if (form.dataset.tkengPass === '1') form.dataset.tkengPass = '0'; }, 3000);
        }, 0);
      }

      if (needAddon) {
        var addonProps = {};
        addonProps[PROP_FOR] = (C.productTitle || '') + (RTL ? ' — כיתוב על שני החלקים (בסיס + גוף הקופה)' : ' — engraving on both parts (base + box)');
        addonProps[PROP_TEXT] = RTL ? 'החלק השני של הכיתוב — הנוסחים בפריט הקופה' : 'Second engraved part — texts on the box item';
        fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: C.addonVariantId, quantity: currentQty(form), properties: addonProps }] })
        })
          .catch(function () {})
          .then(nativeSubmit770);
      } else {
        nativeSubmit770();
      }
    }, true);

    return true;
  }

  /* ---------- מוצרים אחרים: הזרימה הישנה (פר-פריט) ---------- */
  function init() {
    var form = findForm();
    if (!form) return false;
    if (form.dataset.tkengReady === '1') return true;
    form.dataset.tkengReady = '1';

    css();
    var wrap = el('div', 'tkeng tkeng--single');
    wrap.dir = RTL ? 'rtl' : 'ltr';

    var row = el('label', 'tkeng__row');
    var cb = el('input');
    cb.type = 'checkbox';
    cb.id = 'tkeng-toggle';
    row.appendChild(cb);
    var rtxt = el('span');
    rtxt.appendChild(el('span', 'tkeng__ttl', T.toggle + ' '));
    rtxt.appendChild(el('span', 'tkeng__price', '+' + T.price + ' ' + T.perItem));
    var lead = el('span', 'tkeng__lead', T.lead);
    lead.style.display = 'block';
    rtxt.appendChild(lead);
    row.appendChild(rtxt);
    wrap.appendChild(row);

    var body = el('div', 'tkeng__body');
    body.appendChild(el('label', 'tkeng__lbl', T.label));

    var fields = el('div', 'tkeng__fields');
    body.appendChild(fields);

    var meta = el('div', 'tkeng__meta');
    var sum = el('span', 'tkeng__sum', '');
    var sizeNote = el('span', 'tkeng__size', '');
    meta.appendChild(sum);
    meta.appendChild(sizeNote);
    body.appendChild(meta);

    body.appendChild(el('div', 'tkeng__err', T.emptyItems));
    body.appendChild(el('p', 'tkeng__proof', T.rows + ' · ' + T.proof));
    wrap.appendChild(body);

    var host = form.closest('product-form') || form;
    (host.parentNode || document.body).insertBefore(wrap, host);

    var designWrap = el('div', 'tkeng tkeng--sub tkeng--single');
    designWrap.dir = RTL ? 'rtl' : 'ltr';
    var drow = el('label', 'tkeng__row');
    var designCb = el('input');
    designCb.type = 'checkbox';
    designCb.id = 'tkeng-design';
    drow.appendChild(designCb);
    var dtxt = el('span');
    dtxt.appendChild(el('span', 'tkeng__ttl', T.designTtl));
    var dlead = el('span', 'tkeng__lead', T.designLead);
    dlead.style.display = 'block';
    dtxt.appendChild(dlead);
    drow.appendChild(dtxt);
    designWrap.appendChild(drow);
    var dbody = el('div', 'tkeng__body');
    var designTa = el('textarea', 'tkeng__ta');
    designTa.rows = 3;
    designTa.placeholder = T.designPh;
    designTa.setAttribute('maxlength', '300');
    designTa.disabled = true;
    dbody.appendChild(designTa);
    dbody.appendChild(el('div', 'tkeng__err', T.designEmpty));
    dbody.appendChild(el('p', 'tkeng__note', T.designNote));
    designWrap.appendChild(dbody);
    (host.parentNode || document.body).insertBefore(designWrap, host);

    designCb.addEventListener('change', function () {
      designWrap.classList.toggle('is-open', designCb.checked);
      designTa.disabled = !designCb.checked;
      designWrap.classList.remove('is-err');
      if (designCb.checked) setTimeout(function () { designTa.focus(); }, 30);
    });
    designTa.addEventListener('input', function () {
      designWrap.classList.remove('is-err');
    });

    var limit = currentLimit(form);
    var qty = currentQty(form);
    var tas = [];

    function texts() {
      return tas.map(function (t) { return t.value.trim(); });
    }

    function engCount() {
      return texts().filter(function (t) { return t; }).length;
    }

    function paintMeta() {
      var k = engCount();
      sum.textContent = k === 0 ? '' : (k === 1 ? T.sumOne + ' · +' + T.price : T.sum.replace('[k]', String(k)) + ' · +' + (k * PRICE) + ' ₪');
      sizeNote.textContent = limit.label
        ? T.size.replace('[s]', limit.label).replace('[n]', String(limit.n))
        : T.sizeNoLbl.replace('[n]', String(limit.n));
    }

    function bindTa(ta) {
      ta.addEventListener('input', function () {
        var v = clampLines(ta.value);
        if (v.length > limit.n) v = v.slice(0, limit.n);
        if (v !== ta.value) ta.value = v;
        wrap.classList.remove('is-err');
        paintMeta();
      });
    }

    function renderFields() {
      var old = texts();
      fields.textContent = '';
      tas = [];
      wrap.classList.toggle('tkeng--single', qty === 1);
      for (var i = 0; i < qty; i++) {
        var unit = el('div', 'tkeng__unit');
        if (qty > 1) unit.appendChild(el('span', 'tkeng__unitlbl', T.itemLbl.replace('[i]', String(i + 1))));
        var ta = el('textarea', 'tkeng__ta');
        ta.rows = qty > 1 ? 1 : 2;
        ta.placeholder = i === 0 ? T.ph : T.phEmpty;
        ta.setAttribute('maxlength', String(limit.n));
        ta.disabled = !cb.checked;
        ta.value = old[i] || '';
        bindTa(ta);
        unit.appendChild(ta);
        fields.appendChild(unit);
        tas.push(ta);
      }
      paintMeta();
    }

    function refreshState() {
      var nextL = currentLimit(form);
      if (nextL.n !== limit.n || nextL.label !== limit.label) {
        limit = nextL;
        tas.forEach(function (ta) {
          ta.setAttribute('maxlength', String(limit.n));
          if (ta.value.length > limit.n) ta.value = ta.value.slice(0, limit.n);
        });
        paintMeta();
      }
      var nextQ = currentQty(form);
      if (nextQ !== qty) {
        qty = nextQ;
        renderFields();
      }
      if (engMode()) hideEngPicker();
    }

    cb.addEventListener('change', function () {
      wrap.classList.toggle('is-open', cb.checked);
      tas.forEach(function (ta) { ta.disabled = !cb.checked; });
      wrap.classList.remove('is-err');
      if (cb.checked && tas[0]) setTimeout(function () { tas[0].focus(); }, 30);
    });

    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.addEventListener('change', refreshState);
    setInterval(refreshState, 500);
    renderFields();
    if (engMode()) hideEngPicker();

    function sharedProps() {
      var p = {};
      if (designCb.checked && designTa.value.trim()) p[PROP_DESIGN] = designTa.value.trim();
      return p;
    }

    function clearOldHidden() {
      var olds = form.querySelectorAll('input[data-tkeng-prop="1"]');
      for (var i = 0; i < olds.length; i++) olds[i].remove();
    }

    function addHiddenProps(props) {
      var added = [];
      for (var k in props) {
        var hi = document.createElement('input');
        hi.type = 'hidden';
        hi.name = 'properties[' + k + ']';
        hi.value = props[k];
        hi.setAttribute('data-tkeng-prop', '1');
        form.appendChild(hi);
        added.push(hi);
      }
      setTimeout(function () { added.forEach(function (h) { h.remove(); }); }, 2000);
      return added;
    }

    function validateDesign() {
      if (designCb.checked && !designTa.value.trim()) {
        designWrap.classList.add('is-err');
        designTa.focus();
        return false;
      }
      return true;
    }

    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (form.dataset.tkengPass === '1') { form.dataset.tkengPass = '0'; return; }

      if (!cb.checked) {
        if (!validateDesign()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }
        var sp = sharedProps();
        clearOldHidden();
        var hasShared = false;
        for (var kk in sp) { hasShared = true; break; }
        if (hasShared) addHiddenProps(sp);
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      var list = texts();
      var k = list.filter(function (t) { return t; }).length;
      if (k === 0) {
        wrap.classList.add('is-err');
        if (tas[0]) tas[0].focus();
        return;
      }
      if (!validateDesign()) return;

      var lim = currentLimit(form);
      var idInputEl = form.querySelector('input[name="id"]');
      var baseIdStr = idInputEl.value;
      var variantId = parseInt(baseIdStr, 10);
      var qtyInput = qtyInputOf(form);
      var twinStr = engMode() ? twinOf(baseIdStr) : null;
      var shared = sharedProps();

      function engravedProps(t) {
        var props = {};
        props[PROP] = t;
        for (var sk in shared) props[sk] = shared[sk];
        return props;
      }

      var plain = 0;
      var byText = {};
      var order = [];
      list.forEach(function (t) {
        if (!t) { plain++; return; }
        if (!(t in byText)) { byText[t] = 0; order.push(t); }
        byText[t]++;
      });

      var nativeIsPlain = plain > 0;
      var nativeText = null;
      var nativeQty = plain;
      if (!nativeIsPlain) {
        nativeText = order.shift();
        nativeQty = byText[nativeText];
      }

      var items = [];
      if (twinStr) {
        var twinId = parseInt(twinStr, 10);
        order.forEach(function (t) {
          items.push({ id: twinId, quantity: byText[t], properties: engravedProps(t) });
        });
      } else {
        order.forEach(function (t) {
          items.push({ id: variantId, quantity: byText[t], properties: engravedProps(t) });
        });
        var addonTexts = nativeIsPlain ? order.slice() : [nativeText].concat(order);
        addonTexts.forEach(function (t) {
          var props = {};
          props[PROP_TEXT] = t;
          props[PROP_FOR] = (C.productTitle || '') + (lim.label ? ' · ' + lim.label : '');
          items.push({ id: C.addonVariantId, quantity: byText[t] || (t === nativeText ? nativeQty : 1), properties: props });
        });
      }

      function nativeSubmit() {
        if (qtyInput) qtyInput.value = String(nativeQty);
        var swapped = false;
        clearOldHidden();
        var nativeProps = {};
        for (var sk in shared) nativeProps[sk] = shared[sk];
        if (!nativeIsPlain) {
          nativeProps[PROP] = nativeText;
          if (twinStr) { idInputEl.value = twinStr; swapped = true; }
        }
        addHiddenProps(nativeProps);
        form.dataset.tkengPass = '1';
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
        if (swapped) idInputEl.value = baseIdStr;
        setTimeout(function () { if (form.dataset.tkengPass === '1') form.dataset.tkengPass = '0'; }, 3000);
      }

      if (items.length) {
        fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .catch(function () {})
          .then(nativeSubmit);
      } else {
        setTimeout(nativeSubmit, 0);
      }
    }, true);

    return true;
  }

  function initAddonPage() {
    var form = findForm();
    if (!form) return false;
    if (form.dataset.tkengReady === '1') return true;
    form.dataset.tkengReady = '1';
    css();

    var wrap = el('div', 'tkeng is-open tkeng--single');
    wrap.dir = RTL ? 'rtl' : 'ltr';
    var body = el('div', 'tkeng__body');
    var lbl = el('label', 'tkeng__lbl', T.addonLabel);
    lbl.setAttribute('for', 'tkeng-text');
    body.appendChild(lbl);
    var ta = el('textarea', 'tkeng__ta');
    ta.id = 'tkeng-text';
    ta.name = 'properties[' + PROP_TEXT + ']';
    ta.placeholder = T.ph;
    ta.rows = 2;
    ta.setAttribute('maxlength', '85');
    var fid = form.getAttribute('id');
    if (fid) ta.setAttribute('form', fid);
    body.appendChild(ta);
    var meta = el('div', 'tkeng__meta');
    var counter = el('span', '', T.left.replace('[n]', '85'));
    meta.appendChild(counter);
    body.appendChild(meta);
    var err = el('div', 'tkeng__err', T.empty);
    body.appendChild(err);
    body.appendChild(el('p', 'tkeng__proof', T.addonNote + ' ' + T.proof));
    wrap.appendChild(body);

    var host = form.closest('product-form') || form;
    (host.parentNode || document.body).insertBefore(wrap, host);

    var allowed = null;
    function refreshAllowed() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var products = 0, addons = 0;
          (cart.items || []).forEach(function (i) {
            if (i.variant_id === C.addonVariantId) addons += i.quantity;
            else products += i.quantity;
          });
          allowed = Math.max(0, products - addons);
          if (allowed === 0) {
            err.textContent = T.addonBlocked;
            wrap.classList.add('is-err');
          } else if (err.textContent === T.addonBlocked) {
            wrap.classList.remove('is-err');
            err.textContent = T.empty;
          }
        })
        .catch(function () { allowed = null; });
    }
    refreshAllowed();
    setInterval(refreshAllowed, 4000);

    ta.addEventListener('input', function () {
      var v = clampLines(ta.value);
      if (v.length > 85) v = v.slice(0, 85);
      if (v !== ta.value) ta.value = v;
      if (err.textContent === T.empty) wrap.classList.remove('is-err');
      counter.textContent = T.left.replace('[n]', String(85 - ta.value.length));
    });

    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!ta.value.trim()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        err.textContent = T.empty;
        wrap.classList.add('is-err');
        ta.focus();
        return;
      }
      if (allowed !== null) {
        var q = currentQty(form);
        if (allowed === 0) {
          e.preventDefault();
          e.stopImmediatePropagation();
          err.textContent = T.addonBlocked;
          wrap.classList.add('is-err');
          return;
        }
        if (q > allowed) {
          e.preventDefault();
          e.stopImmediatePropagation();
          err.textContent = T.addonMax.replace('[n]', String(allowed));
          wrap.classList.add('is-err');
          return;
        }
      }
    }, true);

    return true;
  }

  function boot() {
    var run = C.isAddon ? initAddonPage : (C.is770 ? init770 : init);
    if (run()) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (run() || tries > 40) clearInterval(t);
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
